import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

import { AlertService, OtpService } from '../_services';
import { Globals } from '../_helpers';

import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';


export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'assessor-verifyotp',
    templateUrl: './verifyotp.component.html',
})

export class VerifyOtpComponent {
    @ViewChild('signupSwal') private signupSwal: SwalComponent;

    public alertOption: SweetAlertOptions = {};
    
    otponeFormControl = new FormControl('', [
        Validators.required,
    ]);
    otptwoFormControl = new FormControl('', [
        Validators.required,
    ]);
    otpthreeFormControl = new FormControl('', [
        Validators.required,
    ]);
    otpfourFormControl = new FormControl('', [
        Validators.required,
    ]);
    matcher = new MyErrorStateMatcher();

    loading = false;
    submitted = false;
    isErrorLogin = false;
    errorMsg: string;
    returnUrl: string;
    userData = {};
    settings = {};
    studentid: number = 0;
    otp_type: number = 1;
    successMsg: string = '';


    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private otpService: OtpService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService
    ) { }


    ngOnInit() {
        var step = this.route.snapshot.paramMap.get("step");
        
        if(step == null || step == undefined)
        {
            this.returnUrl = '/userlogin';
        }
        else{
            this.studentid = parseInt(step);
        }
    }

    public otpSubmit() {
        this.successMsg = '';
        this.submitted = true;

        /* stop here if form is invalid */
        if (this.otponeFormControl.value == '' || this.otptwoFormControl.value == '' || this.otpthreeFormControl.value == '' || this.otpfourFormControl.value == '') {
            this.isErrorLogin = false;
            return false;
        }
        else {
            var userid = sessionStorage.getItem("pkshn_username_ps");
            //console.log(userid); return;
            if(userid == null || userid == undefined)
            {
                var otp = this.otponeFormControl.value + '' + this.otptwoFormControl.value + '' + this.otpthreeFormControl.value + '' + this.otpfourFormControl.value;

                this.otp_type = 1;
                this.loading = true;
                this.spinner.show();
                this.otpService.checkotp(this.globals.root_url, this.studentid, this.otp_type, otp)
                    //.pipe(first())
                    .subscribe(
                        data => {
                            if (data.code == 1000) {
                                this.isErrorLogin = true;                          
                                this.loading = false;
                                this.spinner.hide();
                                //sessionStorage.removeItem("pkshn_username_ps");
                                this.errorMsg = 'Registration has been done successfully. !!';
                                this.signupSwal.show();                             
                                this.goToLogin(); 
                            }
                            else if (data.status == 1001) {
                                this.loading = false;
                                this.isErrorLogin = false;
                                this.errorMsg = data.status;
                            }
                            else {
                                this.isErrorLogin = true;
                                this.errorMsg = 'Otp Expire !!';
                                this.loading = false;
                            }
                            this.spinner.hide();
                        },
                        error => {
                            this.isErrorLogin = true;
                            this.errorMsg = 'Otp Expire !!';
                            this.alertService.error(error);
                            this.loading = false;
                            this.spinner.hide();
                        }
                    );                
            }
            else
            {
                var otp = this.otponeFormControl.value + '' + this.otptwoFormControl.value + '' + this.otpthreeFormControl.value + '' + this.otpfourFormControl.value;

                this.loading = true;
                this.spinner.show();
                this.otp_type = 2;
                //this.otpService.otpverifyforgotpass(this.globals.root_url, this.otp_type, otp, this.studentid, '')
                this.otpService.checkotp(this.globals.root_url, this.studentid, this.otp_type, otp)
                    //.pipe(first())
                    .subscribe(
                        data => {
                            if (data.code == 1000) {
                                this.isErrorLogin = false;                          
                                this.loading = false;
                                this.spinner.hide();
                                //var parms = this.globals.getRandUrl('verify');
                                this.router.navigateByUrl('/reset-password/' + this.studentid);
                            }
                            else if (data.status == 1001) {
                                this.loading = false;
                                this.isErrorLogin = false;

                            }
                            else {
                                this.isErrorLogin = true;
                                this.errorMsg = 'Otp Expire !!';
                                this.loading = false;
                            }
                            this.spinner.hide();
                        },
                        error => {
                            this.isErrorLogin = true;
                            this.errorMsg = 'Otp Expire !!';
                            this.alertService.error(error);
                            this.loading = false;
                            this.spinner.hide();
                        }
                    );  
            }

        }
    }

    public resendOtp() {

        this.successMsg = '';
        this.spinner.show();
        this.otpService.resendVeryfyOtp(this.globals.root_url, this.studentid)
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        this.isErrorLogin = false;
                        this.successMsg = "OTP has been sent on your registered mobile."
                    }
                    else if (data.status == 'COM_TOKEN_ERROR') {
                        this.loading = false;
                        this.isErrorLogin = false;
                        // this.router.navigateByUrl('/login');
                    }
                    else {
                        this.isErrorLogin = true;
                        this.errorMsg = 'Otp Expire !!';
                        this.loading = false;
                    }
                    this.spinner.hide();
                },
                error => {
                    this.isErrorLogin = true;
                    this.errorMsg = 'Otp Expire !!';
                    this.alertService.error(error);
                    this.loading = false;
                    this.spinner.hide();
                }
            );
    }

    public keytab(event, index) {
        var textBox = document.getElementById("otp-" + index);
        textBox.focus();
    }
    goToLogin()
    {
        this.router.navigateByUrl('/userlogin');  
    }
}
